import { getJson, getUrl, httpClient, postJson } from '../../providers/data'
import type {
  Bundle,
  ExportRequest,
  ImportResult,
  LastImportOut,
  PreviewResult,
} from '../../types/apiRequests'

export type ImportItemDecision = 'create' | 'overwrite' | 'skip'

export interface ImportSelections {
  decisions: Record<string, Record<string, ImportItemDecision>>
}

const postMultipart = async <T>(url: string, formData: FormData): Promise<T> => {
  const response = await httpClient(url, { method: 'POST', body: formData })
  return response.json as T
}

export const requestExport = async (body: ExportRequest): Promise<Bundle> => (
  postJson<Bundle>(`${getUrl()}/import_export/export`, body)
)

export const previewBundle = async (file: File): Promise<PreviewResult> => {
  const formData = new FormData()
  formData.append('file', file)
  return postMultipart<PreviewResult>(`${getUrl()}/import_export/preview`, formData)
}

export const executeImport = async (
  file: File,
  selections: ImportSelections,
): Promise<ImportResult> => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('selections', JSON.stringify(selections))
  return postMultipart<ImportResult>(`${getUrl()}/import_export/import`, formData)
}

export const getLastImport = async (): Promise<LastImportOut> => (
  getJson<LastImportOut>(`${getUrl()}/import_export/last_import`)
)

export const downloadBundle = (bundle: Bundle): void => {
  const filename = `secureaccess-export-${
    new Date().toISOString().slice(0, 10)
  }.json`
  const blob = new Blob([JSON.stringify(bundle, null, 2)], {
    type: 'application/json',
  })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
